import { CONNECTION } from "../../config/Connections";
import { CONFIG_ } from "../../config/Config";
import { successnotify } from "../../components/ToasNotif/Toast";
import { actGetDataInvoiceBySiswa } from "../Invoice";
import { __openModal } from "../Modal";
import { actGetDataPaymentBySiswa } from "./Payment_act";

var get = "/in-payment";
var post = "/in-payment";
export const actGetDataPaymentInternal = () => {
  return (dispatch) => {
    let config = CONFIG_({ url: get, method: "GET" });
    dispatch({ type: "LOADING_PAYMENTINTERNAL_PAYMENT" });
    CONNECTION(config)
      .then((response) => {
        const { status, data } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_PAYMENTINTERNAL_PAYMENT",
            message: "Success get data",
            data: data,
            code: status,
          });
        }
        return dispatch({
          type: "ERROR_PAYMENTINTERNAL_PAYMENT",
          message: "failed",
        });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_PAYMENTINTERNAL_PAYMENT",
          message: "Network error..",
        });
      });
  };
};

export const actPostDataPaymentInternal = (params) => {
  return (dispatch) => {
    const { siswa } = params;
    let config = CONFIG_({ url: post, data: params, method: "POST" });
    dispatch({ type: "LOADING_PAYMENTINTERNAL_PAYMENT" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Payment has been created");
          dispatch(
            __openModal({ modal: "MODAL_ADD_PAYMENTINTERNAL", open: false })
          );
          dispatch(actGetDataInvoiceBySiswa(siswa));
          return dispatch(actGetDataPaymentBySiswa(siswa));
        }
        return dispatch({
          type: "ERROR_PAYMENTINTERNAL_PAYMENT",
          message: "failed",
        });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_PAYMENTINTERNAL_PAYMENT",
          message: "Network error..",
        });
      });
  };
};

export const actUpdateDataPaymentInternal = (params) => {
  return (dispatch) => {
    const { id, siswa } = params;
    let config = CONFIG_({ url: post + "/" + id, data: params, method: "PUT" });
    dispatch({ type: "LOADING_PAYMENTINTERNAL_PAYMENT" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 202) {
          successnotify("Payment has been update");
          dispatch(
            __openModal({ modal: "MODAL_EDIT_PAYMENTHISTORY", open: false })
          );
          dispatch(actGetDataPaymentBySiswa(btoa(siswa)));
          return dispatch(actGetDataInvoiceBySiswa(btoa(siswa)));
        }
        return dispatch({
          type: "ERROR_PAYMENTINTERNAL_PAYMENT",
          message: "failed",
        });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_PAYMENTINTERNAL_PAYMENT",
          message: "Network error..",
        });
      });
  };
};

export const actDetailDataPaymentInternal = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "GET" });
    dispatch({ type: "LOADING_PAYMENTINTERNAL_PAYMENT" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_PAYMENTINTERNAL_PAYMENT",
            message: "Success get data",
          });
        }
        return dispatch({
          type: "ERROR_PAYMENTINTERNAL_PAYMENT",
          message: "failed",
        });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_PAYMENTINTERNAL_PAYMENT",
          message: "Network error..",
        });
      });
  };
};

export const actDeleteDataPaymentInternal = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "DELETE" });
    dispatch({ type: "LOADING_PAYMENTINTERNAL_PAYMENT" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_PAYMENTINTERNAL_PAYMENT",
            message: "Success get data",
          });
        }
        return dispatch({
          type: "ERROR_PAYMENTINTERNAL_PAYMENT",
          message: "failed",
        });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_PAYMENTINTERNAL_PAYMENT",
          message: "Network error..",
        });
      });
  };
};
